/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspacesRouteImport } from './routes/workspaces'
import { Route as VolumesRouteImport } from './routes/volumes'
import { Route as UsersRouteImport } from './routes/users'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ServersRouteImport } from './routes/servers'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as NetworksRouteImport } from './routes/networks'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImagesRouteImport } from './routes/images'
import { Route as EnvironmentsRouteImport } from './routes/environments'
import { Route as AuditLogsRouteImport } from './routes/audit-logs'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspacesIndexRouteImport } from './routes/workspaces.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as ServersIndexRouteImport } from './routes/servers.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as WorkspacesWorkspaceIdRouteImport } from './routes/workspaces.$workspaceId'
import { Route as SettingsTokensRouteImport } from './routes/settings.tokens'
import { Route as SettingsServersRouteImport } from './routes/settings.servers'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsCreditsRouteImport } from './routes/settings.credits'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as ServersServerIdRouteImport } from './routes/servers.$serverId'
import { Route as AdminWorkspacesRouteImport } from './routes/admin.workspaces'
import { Route as AdminVolumesRouteImport } from './routes/admin.volumes'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminServersRouteImport } from './routes/admin.servers'
import { Route as AdminQuotasRouteImport } from './routes/admin.quotas'
import { Route as AdminPlansRouteImport } from './routes/admin.plans'
import { Route as AdminPermissionsRouteImport } from './routes/admin.permissions'
import { Route as AdminMaintenanceWindowsRouteImport } from './routes/admin.maintenance-windows'
import { Route as AdminIpRestrictionsRouteImport } from './routes/admin.ip-restrictions'
import { Route as AdminHealthRouteImport } from './routes/admin.health'
import { Route as AdminEnvironmentsRouteImport } from './routes/admin.environments'
import { Route as AdminCreditsRouteImport } from './routes/admin.credits'
import { Route as AdminAuditLogsRouteImport } from './routes/admin.audit-logs'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminUsersIndexRouteImport } from './routes/admin.users.index'
import { Route as UserUsernameServerNameRouteImport } from './routes/user.$username.$serverName'
import { Route as ServersServerIdMetricsRouteImport } from './routes/servers.$serverId.metrics'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin.users.$userId'

const WorkspacesRoute = WorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => rootRouteImport,
} as any)
const VolumesRoute = VolumesRouteImport.update({
  id: '/volumes',
  path: '/volumes',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ServersRoute = ServersRouteImport.update({
  id: '/servers',
  path: '/servers',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const NetworksRoute = NetworksRouteImport.update({
  id: '/networks',
  path: '/networks',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ImagesRoute = ImagesRouteImport.update({
  id: '/images',
  path: '/images',
  getParentRoute: () => rootRouteImport,
} as any)
const EnvironmentsRoute = EnvironmentsRouteImport.update({
  id: '/environments',
  path: '/environments',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogsRoute = AuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIndexRoute = WorkspacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspacesRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const ServersIndexRoute = ServersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ServersRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const WorkspacesWorkspaceIdRoute = WorkspacesWorkspaceIdRouteImport.update({
  id: '/$workspaceId',
  path: '/$workspaceId',
  getParentRoute: () => WorkspacesRoute,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsServersRoute = SettingsServersRouteImport.update({
  id: '/servers',
  path: '/servers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCreditsRoute = SettingsCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const ServersServerIdRoute = ServersServerIdRouteImport.update({
  id: '/$serverId',
  path: '/$serverId',
  getParentRoute: () => ServersRoute,
} as any)
const AdminWorkspacesRoute = AdminWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVolumesRoute = AdminVolumesRouteImport.update({
  id: '/volumes',
  path: '/volumes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminServersRoute = AdminServersRouteImport.update({
  id: '/servers',
  path: '/servers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuotasRoute = AdminQuotasRouteImport.update({
  id: '/quotas',
  path: '/quotas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPermissionsRoute = AdminPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMaintenanceWindowsRoute = AdminMaintenanceWindowsRouteImport.update({
  id: '/maintenance-windows',
  path: '/maintenance-windows',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIpRestrictionsRoute = AdminIpRestrictionsRouteImport.update({
  id: '/ip-restrictions',
  path: '/ip-restrictions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEnvironmentsRoute = AdminEnvironmentsRouteImport.update({
  id: '/environments',
  path: '/environments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCreditsRoute = AdminCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any)
const UserUsernameServerNameRoute = UserUsernameServerNameRouteImport.update({
  id: '/user/$username/$serverName',
  path: '/user/$username/$serverName',
  getParentRoute: () => rootRouteImport,
} as any)
const ServersServerIdMetricsRoute = ServersServerIdMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => ServersServerIdRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AdminUsersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/audit-logs': typeof AuditLogsRoute
  '/environments': typeof EnvironmentsRoute
  '/images': typeof ImagesRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/networks': typeof NetworksRoute
  '/notifications': typeof NotificationsRoute
  '/plans': typeof PlansRoute
  '/servers': typeof ServersRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/support': typeof SupportRoute
  '/usage': typeof UsageRoute
  '/users': typeof UsersRoute
  '/volumes': typeof VolumesRoute
  '/workspaces': typeof WorkspacesRouteWithChildren
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/environments': typeof AdminEnvironmentsRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/ip-restrictions': typeof AdminIpRestrictionsRoute
  '/admin/maintenance-windows': typeof AdminMaintenanceWindowsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/quotas': typeof AdminQuotasRoute
  '/admin/servers': typeof AdminServersRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/volumes': typeof AdminVolumesRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/servers/$serverId': typeof ServersServerIdRouteWithChildren
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/credits': typeof SettingsCreditsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/servers': typeof SettingsServersRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRoute
  '/admin/': typeof AdminIndexRoute
  '/servers/': typeof ServersIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/servers/$serverId/metrics': typeof ServersServerIdMetricsRoute
  '/user/$username/$serverName': typeof UserUsernameServerNameRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/audit-logs': typeof AuditLogsRoute
  '/environments': typeof EnvironmentsRoute
  '/images': typeof ImagesRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/networks': typeof NetworksRoute
  '/notifications': typeof NotificationsRoute
  '/plans': typeof PlansRoute
  '/support': typeof SupportRoute
  '/usage': typeof UsageRoute
  '/users': typeof UsersRoute
  '/volumes': typeof VolumesRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/environments': typeof AdminEnvironmentsRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/ip-restrictions': typeof AdminIpRestrictionsRoute
  '/admin/maintenance-windows': typeof AdminMaintenanceWindowsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/quotas': typeof AdminQuotasRoute
  '/admin/servers': typeof AdminServersRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/volumes': typeof AdminVolumesRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/servers/$serverId': typeof ServersServerIdRouteWithChildren
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/credits': typeof SettingsCreditsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/servers': typeof SettingsServersRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRoute
  '/admin': typeof AdminIndexRoute
  '/servers': typeof ServersIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/workspaces': typeof WorkspacesIndexRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/servers/$serverId/metrics': typeof ServersServerIdMetricsRoute
  '/user/$username/$serverName': typeof UserUsernameServerNameRoute
  '/admin/users': typeof AdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/audit-logs': typeof AuditLogsRoute
  '/environments': typeof EnvironmentsRoute
  '/images': typeof ImagesRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/networks': typeof NetworksRoute
  '/notifications': typeof NotificationsRoute
  '/plans': typeof PlansRoute
  '/servers': typeof ServersRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/support': typeof SupportRoute
  '/usage': typeof UsageRoute
  '/users': typeof UsersRoute
  '/volumes': typeof VolumesRoute
  '/workspaces': typeof WorkspacesRouteWithChildren
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/environments': typeof AdminEnvironmentsRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/ip-restrictions': typeof AdminIpRestrictionsRoute
  '/admin/maintenance-windows': typeof AdminMaintenanceWindowsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/quotas': typeof AdminQuotasRoute
  '/admin/servers': typeof AdminServersRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/volumes': typeof AdminVolumesRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/servers/$serverId': typeof ServersServerIdRouteWithChildren
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/credits': typeof SettingsCreditsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/servers': typeof SettingsServersRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRoute
  '/admin/': typeof AdminIndexRoute
  '/servers/': typeof ServersIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/servers/$serverId/metrics': typeof ServersServerIdMetricsRoute
  '/user/$username/$serverName': typeof UserUsernameServerNameRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/admin'
    | '/analytics'
    | '/audit-logs'
    | '/environments'
    | '/images'
    | '/login'
    | '/maintenance'
    | '/networks'
    | '/notifications'
    | '/plans'
    | '/servers'
    | '/settings'
    | '/support'
    | '/usage'
    | '/users'
    | '/volumes'
    | '/workspaces'
    | '/admin/analytics'
    | '/admin/audit-logs'
    | '/admin/credits'
    | '/admin/environments'
    | '/admin/health'
    | '/admin/ip-restrictions'
    | '/admin/maintenance-windows'
    | '/admin/permissions'
    | '/admin/plans'
    | '/admin/quotas'
    | '/admin/servers'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/volumes'
    | '/admin/workspaces'
    | '/servers/$serverId'
    | '/settings/appearance'
    | '/settings/credits'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/servers'
    | '/settings/tokens'
    | '/workspaces/$workspaceId'
    | '/admin/'
    | '/servers/'
    | '/settings/'
    | '/workspaces/'
    | '/admin/users/$userId'
    | '/servers/$serverId/metrics'
    | '/user/$username/$serverName'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/analytics'
    | '/audit-logs'
    | '/environments'
    | '/images'
    | '/login'
    | '/maintenance'
    | '/networks'
    | '/notifications'
    | '/plans'
    | '/support'
    | '/usage'
    | '/users'
    | '/volumes'
    | '/admin/analytics'
    | '/admin/audit-logs'
    | '/admin/credits'
    | '/admin/environments'
    | '/admin/health'
    | '/admin/ip-restrictions'
    | '/admin/maintenance-windows'
    | '/admin/permissions'
    | '/admin/plans'
    | '/admin/quotas'
    | '/admin/servers'
    | '/admin/settings'
    | '/admin/volumes'
    | '/admin/workspaces'
    | '/servers/$serverId'
    | '/settings/appearance'
    | '/settings/credits'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/servers'
    | '/settings/tokens'
    | '/workspaces/$workspaceId'
    | '/admin'
    | '/servers'
    | '/settings'
    | '/workspaces'
    | '/admin/users/$userId'
    | '/servers/$serverId/metrics'
    | '/user/$username/$serverName'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/admin'
    | '/analytics'
    | '/audit-logs'
    | '/environments'
    | '/images'
    | '/login'
    | '/maintenance'
    | '/networks'
    | '/notifications'
    | '/plans'
    | '/servers'
    | '/settings'
    | '/support'
    | '/usage'
    | '/users'
    | '/volumes'
    | '/workspaces'
    | '/admin/analytics'
    | '/admin/audit-logs'
    | '/admin/credits'
    | '/admin/environments'
    | '/admin/health'
    | '/admin/ip-restrictions'
    | '/admin/maintenance-windows'
    | '/admin/permissions'
    | '/admin/plans'
    | '/admin/quotas'
    | '/admin/servers'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/volumes'
    | '/admin/workspaces'
    | '/servers/$serverId'
    | '/settings/appearance'
    | '/settings/credits'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/servers'
    | '/settings/tokens'
    | '/workspaces/$workspaceId'
    | '/admin/'
    | '/servers/'
    | '/settings/'
    | '/workspaces/'
    | '/admin/users/$userId'
    | '/servers/$serverId/metrics'
    | '/user/$username/$serverName'
    | '/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AdminRoute: typeof AdminRouteWithChildren
  AnalyticsRoute: typeof AnalyticsRoute
  AuditLogsRoute: typeof AuditLogsRoute
  EnvironmentsRoute: typeof EnvironmentsRoute
  ImagesRoute: typeof ImagesRoute
  LoginRoute: typeof LoginRoute
  MaintenanceRoute: typeof MaintenanceRoute
  NetworksRoute: typeof NetworksRoute
  NotificationsRoute: typeof NotificationsRoute
  PlansRoute: typeof PlansRoute
  ServersRoute: typeof ServersRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  SupportRoute: typeof SupportRoute
  UsageRoute: typeof UsageRoute
  UsersRoute: typeof UsersRoute
  VolumesRoute: typeof VolumesRoute
  WorkspacesRoute: typeof WorkspacesRouteWithChildren
  UserUsernameServerNameRoute: typeof UserUsernameServerNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspaces': {
      id: '/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WorkspacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/volumes': {
      id: '/volumes'
      path: '/volumes'
      fullPath: '/volumes'
      preLoaderRoute: typeof VolumesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/servers': {
      id: '/servers'
      path: '/servers'
      fullPath: '/servers'
      preLoaderRoute: typeof ServersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/networks': {
      id: '/networks'
      path: '/networks'
      fullPath: '/networks'
      preLoaderRoute: typeof NetworksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/images': {
      id: '/images'
      path: '/images'
      fullPath: '/images'
      preLoaderRoute: typeof ImagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/environments': {
      id: '/environments'
      path: '/environments'
      fullPath: '/environments'
      preLoaderRoute: typeof EnvironmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-logs': {
      id: '/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuditLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/': {
      id: '/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof WorkspacesIndexRouteImport
      parentRoute: typeof WorkspacesRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/servers/': {
      id: '/servers/'
      path: '/'
      fullPath: '/servers/'
      preLoaderRoute: typeof ServersIndexRouteImport
      parentRoute: typeof ServersRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/workspaces/$workspaceId': {
      id: '/workspaces/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdRouteImport
      parentRoute: typeof WorkspacesRoute
    }
    '/settings/tokens': {
      id: '/settings/tokens'
      path: '/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/servers': {
      id: '/settings/servers'
      path: '/servers'
      fullPath: '/settings/servers'
      preLoaderRoute: typeof SettingsServersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/credits': {
      id: '/settings/credits'
      path: '/credits'
      fullPath: '/settings/credits'
      preLoaderRoute: typeof SettingsCreditsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/servers/$serverId': {
      id: '/servers/$serverId'
      path: '/$serverId'
      fullPath: '/servers/$serverId'
      preLoaderRoute: typeof ServersServerIdRouteImport
      parentRoute: typeof ServersRoute
    }
    '/admin/workspaces': {
      id: '/admin/workspaces'
      path: '/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AdminWorkspacesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/volumes': {
      id: '/admin/volumes'
      path: '/volumes'
      fullPath: '/admin/volumes'
      preLoaderRoute: typeof AdminVolumesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/servers': {
      id: '/admin/servers'
      path: '/servers'
      fullPath: '/admin/servers'
      preLoaderRoute: typeof AdminServersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quotas': {
      id: '/admin/quotas'
      path: '/quotas'
      fullPath: '/admin/quotas'
      preLoaderRoute: typeof AdminQuotasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/permissions': {
      id: '/admin/permissions'
      path: '/permissions'
      fullPath: '/admin/permissions'
      preLoaderRoute: typeof AdminPermissionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/maintenance-windows': {
      id: '/admin/maintenance-windows'
      path: '/maintenance-windows'
      fullPath: '/admin/maintenance-windows'
      preLoaderRoute: typeof AdminMaintenanceWindowsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ip-restrictions': {
      id: '/admin/ip-restrictions'
      path: '/ip-restrictions'
      fullPath: '/admin/ip-restrictions'
      preLoaderRoute: typeof AdminIpRestrictionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/environments': {
      id: '/admin/environments'
      path: '/environments'
      fullPath: '/admin/environments'
      preLoaderRoute: typeof AdminEnvironmentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/credits': {
      id: '/admin/credits'
      path: '/credits'
      fullPath: '/admin/credits'
      preLoaderRoute: typeof AdminCreditsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-logs': {
      id: '/admin/audit-logs'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof AdminAuditLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/user/$username/$serverName': {
      id: '/user/$username/$serverName'
      path: '/user/$username/$serverName'
      fullPath: '/user/$username/$serverName'
      preLoaderRoute: typeof UserUsernameServerNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/servers/$serverId/metrics': {
      id: '/servers/$serverId/metrics'
      path: '/metrics'
      fullPath: '/servers/$serverId/metrics'
      preLoaderRoute: typeof ServersServerIdMetricsRouteImport
      parentRoute: typeof ServersServerIdRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminUsersRoute
    }
  }
}

interface AdminUsersRouteChildren {
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminAuditLogsRoute: typeof AdminAuditLogsRoute
  AdminCreditsRoute: typeof AdminCreditsRoute
  AdminEnvironmentsRoute: typeof AdminEnvironmentsRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminIpRestrictionsRoute: typeof AdminIpRestrictionsRoute
  AdminMaintenanceWindowsRoute: typeof AdminMaintenanceWindowsRoute
  AdminPermissionsRoute: typeof AdminPermissionsRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminQuotasRoute: typeof AdminQuotasRoute
  AdminServersRoute: typeof AdminServersRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminVolumesRoute: typeof AdminVolumesRoute
  AdminWorkspacesRoute: typeof AdminWorkspacesRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminAuditLogsRoute: AdminAuditLogsRoute,
  AdminCreditsRoute: AdminCreditsRoute,
  AdminEnvironmentsRoute: AdminEnvironmentsRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminIpRestrictionsRoute: AdminIpRestrictionsRoute,
  AdminMaintenanceWindowsRoute: AdminMaintenanceWindowsRoute,
  AdminPermissionsRoute: AdminPermissionsRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminQuotasRoute: AdminQuotasRoute,
  AdminServersRoute: AdminServersRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminVolumesRoute: AdminVolumesRoute,
  AdminWorkspacesRoute: AdminWorkspacesRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ServersServerIdRouteChildren {
  ServersServerIdMetricsRoute: typeof ServersServerIdMetricsRoute
}

const ServersServerIdRouteChildren: ServersServerIdRouteChildren = {
  ServersServerIdMetricsRoute: ServersServerIdMetricsRoute,
}

const ServersServerIdRouteWithChildren = ServersServerIdRoute._addFileChildren(
  ServersServerIdRouteChildren,
)

interface ServersRouteChildren {
  ServersServerIdRoute: typeof ServersServerIdRouteWithChildren
  ServersIndexRoute: typeof ServersIndexRoute
}

const ServersRouteChildren: ServersRouteChildren = {
  ServersServerIdRoute: ServersServerIdRouteWithChildren,
  ServersIndexRoute: ServersIndexRoute,
}

const ServersRouteWithChildren =
  ServersRoute._addFileChildren(ServersRouteChildren)

interface SettingsRouteChildren {
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsCreditsRoute: typeof SettingsCreditsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsServersRoute: typeof SettingsServersRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsCreditsRoute: SettingsCreditsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsServersRoute: SettingsServersRoute,
  SettingsTokensRoute: SettingsTokensRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface WorkspacesRouteChildren {
  WorkspacesWorkspaceIdRoute: typeof WorkspacesWorkspaceIdRoute
  WorkspacesIndexRoute: typeof WorkspacesIndexRoute
}

const WorkspacesRouteChildren: WorkspacesRouteChildren = {
  WorkspacesWorkspaceIdRoute: WorkspacesWorkspaceIdRoute,
  WorkspacesIndexRoute: WorkspacesIndexRoute,
}

const WorkspacesRouteWithChildren = WorkspacesRoute._addFileChildren(
  WorkspacesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AdminRoute: AdminRouteWithChildren,
  AnalyticsRoute: AnalyticsRoute,
  AuditLogsRoute: AuditLogsRoute,
  EnvironmentsRoute: EnvironmentsRoute,
  ImagesRoute: ImagesRoute,
  LoginRoute: LoginRoute,
  MaintenanceRoute: MaintenanceRoute,
  NetworksRoute: NetworksRoute,
  NotificationsRoute: NotificationsRoute,
  PlansRoute: PlansRoute,
  ServersRoute: ServersRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  SupportRoute: SupportRoute,
  UsageRoute: UsageRoute,
  UsersRoute: UsersRoute,
  VolumesRoute: VolumesRoute,
  WorkspacesRoute: WorkspacesRouteWithChildren,
  UserUsernameServerNameRoute: UserUsernameServerNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
